// extracted by mini-css-extract-plugin
export default {"error":"TwoDGrid_error__6IEkH"};